var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.isEuropeanaEntity)?_c('SmartLink',{attrs:{"destination":{ name: 'collections-type-all', params: { type: _vm.destination.type, pathMatch: _vm.destination.id } }}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]):[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }